import axios from "axios";
import { checkEnvUrl, getUrls } from "../utils/urls.js";
import { getCookie } from "../services/utils/cookies.js";
class CliengoClientError extends Error {
  constructor(message){
    super(message);
    this.name = 'CliengoClientError';
  }
}
export const getCliengoClient = (args)=>{
  let baseUrl = args.baseUrl || '';
  let jwt = args.jwt || '';
  if (!baseUrl) {
    const env = process.env.ENVIRONMENT || process.env.NEXT_PUBLIC_ENVIRONMENT;
    if (!env) {
      console.warn('CliengoClient: Environment is not set, serving stage URL by default.');
    }
    checkEnvUrl('CliengoClient', baseUrl);
    baseUrl = getUrls(env).API_URL;
    if (!baseUrl) {
      throw new CliengoClientError('Base URL is required');
    }
  }
  if (!jwt) {
    const _jwt = getCookie('jwt');
    if (!_jwt) {
      throw new CliengoClientError('JWT is required');
    }
    jwt = _jwt;
  }
  const options = {
    baseURL: baseUrl,
    headers: {
      Authorization: jwt
    }
  };
  return axios.create(options);
};
//# sourceMappingURL=cliengo.client.js.map